import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/global.css'

// Hide loading screen when React is ready
const hideLoadingScreen = () => {
  const loadingScreen = document.getElementById('loading-screen')
  if (loadingScreen) {
    loadingScreen.classList.add('hidden')
    setTimeout(() => loadingScreen.remove(), 500)
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  // StrictMode disabled untuk prevent double initialization WebGL context
  // <React.StrictMode>
    <App />
  // </React.StrictMode>,
)

// Hide loading screen after mount
setTimeout(hideLoadingScreen, 1000)

